// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Yl-z","tupacHeader":"Zl-z","tupacHeader2":"_l-z","tupacMenu":"am-z","tupacMenu2":"bm-z","tupacMain":"cm-z","tupacMain2":"dm-z"};